import { Button } from "common/components/ui/Button";
import { DialogDescription, DialogTitle } from "common/components/ui/Dialog";
import { DrawerDescription, DrawerTitle } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import useMembersMutations from "../../datahooks/useMembersMutations";

interface RevokeMemberProps {
  inviteToken: string;
  onBack: () => void;
}

export default function RevokeInvite({
  inviteToken,
  onBack,
}: RevokeMemberProps) {
  const isDesktop = useTwBreakpoint("lg");

  const { revokeInvite, isRevokingInvite } = useMembersMutations();

  function onRevokeInvite() {
    revokeInvite({ inviteToken }).then(onBack);
  }

  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;

  return (
    <>
      <Title>Revoke invite?</Title>
      <Description className="mb-8">
        This email will no longer be able to join your workspace
      </Description>

      <div className="flex items-center justify-between gap-x-2.5">
        <Button
          variant="secondary-black"
          className="lg:flex-1"
          disabled={isRevokingInvite}
          onClick={onBack}
        >
          Cancel
        </Button>

        <Button
          variant="outline-danger"
          className="lg:flex-1"
          isLoading={isRevokingInvite}
          onClick={onRevokeInvite}
        >
          Revoke invite
        </Button>
      </div>
    </>
  );
}
